import React from 'react';
import JITLoad from '~/helpers/jit-load';
import { useLocation } from 'react-router-dom';
import useUserContext from '~/contexts/user';
import linkHelper from '~/helpers/link';
function LoginLink() {
    // It's not used directly, but loginLink changes when it does
    useLocation();
    return (React.createElement("li", { className: "login-menu nav-menu-item rightmost" },
        React.createElement("a", { href: linkHelper.loginLink(), className: "pardotTrackClick", "data-local": "true" }, "Log in")));
}
export default function LoginMenu() {
    const { userModel } = useUserContext();
    const loggedIn = Boolean(typeof userModel === 'object' && userModel.id);
    return loggedIn ? (React.createElement(JITLoad, { importFn: () => import('./login-menu-with-dropdown') })) : (React.createElement(LoginLink, null));
}
